import { connect } from 'react-redux';
import { withConditionalRendering } from 'swag-client-common/components/utils/with-conditional-rendering';
import { hideForLimitedBuyingCartView } from 'swag-client-common/redux/cart/cart.utils';
import { onAddProductsClickAction, onEditBoxClickAction } from '../../../../../customer/redux/box-builder/box-builder.actions';
import BoxControlButtons from './box-control-buttons';
const mapDispatchToProps = dispatch => ({
  onEditBoxClick: id => {
    dispatch(onEditBoxClickAction(id));
  },
  onAddProductsClick: id => {
    dispatch(onAddProductsClickAction(id));
  }
});
export default withConditionalRendering(connect(null, mapDispatchToProps)(BoxControlButtons), hideForLimitedBuyingCartView);